export default () => 'Pricing – Conjugr8'
